import React, { useState } from 'react';

import { arrayOf, bool, func, object } from 'prop-types';
import { propTypes } from '../../util/types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { findOptionsByFilterLabel } from '../../util/search';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import classNames from 'classnames';
import moment from 'moment';
import css from './GigAttendance.module.css';
import { formatMoney, unitDivisor } from '../../util/currency';
import {
  composeValidators,
  isHourAboveMinValue,
  isHourBelowMaxValue,
  isHourBetweenValue,
  required,
} from '../../util/validators';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import Form from '../Form/Form';
import { ensureCurrentUser } from '../../util/data';
import { languageSelectOptions, MAX_WORKING_HOUR } from '../../marketplace-custom-config';
import { InlineTextButton, PrimaryButton, SecondaryButton } from '../Button/Button';
import { ReactComponent as ArrowDown } from '../../assets/svg/arrowDown.svg';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { timestatementTab } from '../../containers/WorkerTimestatementPage/constant';
import { intlShape } from '../../util/reactIntl';
import { adminTimestatmentType } from '../../containers/AdminTimestatementDetailsPage/constant';
import { createSlug } from '../../util/urlHelpers';
import NamedLink from '../NamedLink/NamedLink';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import Modal from '../Modal/Modal';
const { Money } = sdkTypes;

const ONE_DAY_HOURS = 24;

const subcategoryOptions = findOptionsByFilterLabel('Subcategory', config.custom.filters);

const formatHour = (hour, userNativeLang, showHourSuffix = true) => {
  const hoursStr = userNativeLang === languageSelectOptions.fr.value ? 'Heures' : 'Hours';
  const hourStr = userNativeLang === languageSelectOptions.fr.value ? 'Heure' : 'Hour';
  const suffix = hour > 9 ? hoursStr : hourStr;
  const hourInt = parseInt(hour);
  const min = Math.round((hour - hourInt) * 60);
  const prefix = `${hourInt > 9 ? '' : '0'}${hourInt}:${min > 9 ? '' : '0'}${min}`;
  return prefix + `${showHourSuffix ? suffix : ''}`;
};

const getTotalHourFromString = string => {
  const timeArr = (string || '').split(':');
  if (timeArr.length < 1) return 0;
  const [hour, min, sec] = timeArr;
  const hourInt = parseInt(hour, 10);
  const minInt = parseInt(min, 10);
  const secInt = parseInt(sec, 10);
  if (isNaN(hourInt)) return 0;
  let totalHours = hourInt;
  const totalMin = (minInt || 0) + (secInt || 0) / 60;
  totalHours += totalMin / 60;
  return totalHours;
};

const getWorkSubcat = listing => {
  const {
    attributes: {
      publicData: { jobCategories },
    },
  } = listing;
  const [cate] = jobCategories;
  const subcateKey = `${cate.category}Subcategory`;
  const subcateList = subcategoryOptions[subcateKey] || [];
  return subcateList.find(subcate => subcate.key === cate.subCategory);
};

const formatMoneyAmount = (amount, intl) => {
  const totalPaymentInSubunit = (amount || 0) * unitDivisor(config.currency);
  return formatMoney(intl, new Money(totalPaymentInSubunit, config.currency));
};

const getTotalPayment = (intl, timeStatement) => {
  const { finalPayment } = timeStatement;
  return formatMoneyAmount(finalPayment, intl);
};

const getTotalWorkingHour = (timeStatement, userNativeLang) => {
  const { attendance = [] } = timeStatement;
  const totalHours = attendance.reduce((acc, at) => acc + at.totalWorkingHour, 0);
  return formatHour(totalHours, userNativeLang);
};

const EditableDiv = props => {
  const {
    isEditable,
    inputName,
    value,
    inputLabel,
    inputPlaceholder,
    inputId,
    validate,
    className,
    onChange,
    ...rest
  } = props;
  return isEditable ? (
    <FieldTextInput
      label={inputLabel}
      placeholder={inputPlaceholder}
      name={inputName}
      id={inputId}
      validate={validate}
      className={className}
      onChange={onChange}
      type="text"
      {...rest}
    />
  ) : (
    <div className={className}>
      <label>{inputLabel}</label>
      <span>{value}</span>
    </div>
  );
};

const Attendance = props => {
  const {
    att,
    onPropsUpdateTimestatment,
    onPropsUserConfrimAttendence,
    onPropsNoShowSubmit,
    onPropsAcceptWorkLog,
    onPropsDisputeSolved,
    onPropsDisputeRaised,
    isProvider,
    isSuperAdmin,
    userNativeLang,
    intl,
    timeStateUpdateInProgress,
    timeStatementUpdateError,
    price,
    lastSubmitIds,
  } = props;

  const {
    endingShiftDateTime,
    isWorkerMarkedNoShow,
    isProviderMarkedNoShow,
    isSuperAdminMarkedNoShow,
    isWorkerConfirmedAttendance,
    isProviderConfirmedAttendance,
    breakTimeGivenByProvider = 0,
    breakTimeGivenByWorker = 0,
    overTimeGivenByProvider = 0,
    overTimeGivenByWorker = 0,
    startingShiftDateTime,
    workerStartingShiftDateTime = startingShiftDateTime,
    workerEndingShiftDateTime = endingShiftDateTime,
    totalWorkingHour,
    totalWorkingHourByProvider = totalWorkingHour,
    totalWorkingHourByWorker = totalWorkingHour,
    isWorkerLogAcceptedByAdmin = false,
    isProviderLogAcceptedByAdmin = false,
    attendanceStartDate = startingShiftDateTime,
    attendanceEndDate = endingShiftDateTime,
    attendanceStatus,
    isDisputeMarkedSolvedByAdmin,
    isDisputeRaisedByProvider,
    isDisputeRaisedByWorker,
    lastConfirmedWorkingHour = totalWorkingHour,
    paymentDate,
    disputeMessage,
    _id,
  } = att;

  const userUtcOffset = Math.abs(moment().utcOffset());
  const isPositiveOffset = moment().utcOffset() > 0;
  const startDate = formateDate(startingShiftDateTime);
  const endDate = formateDate(endingShiftDateTime);
  const startTime = formateTime(startingShiftDateTime);
  const endTime = formateTime(endingShiftDateTime);
  const workerStartDate = formateDate(workerStartingShiftDateTime);
  const workerEndDate = formateDate(workerEndingShiftDateTime);
  const workerStartTime = formateTime(workerStartingShiftDateTime);
  const workerEndTime = formateTime(workerEndingShiftDateTime);
  const type = isSuperAdmin ? 'admin' : isProvider ? 'business' : 'worker';
  const totalWorkingHourStr = formatHour(totalWorkingHour, userNativeLang, false);
  const totalWorkingHourByProviderStr = totalWorkingHourByProvider
    ? formatHour(totalWorkingHourByProvider, userNativeLang, false)
    : totalWorkingHourStr;
  const totalWorkingHourByWorkerStr = totalWorkingHourByWorker
    ? formatHour(totalWorkingHourByWorker, userNativeLang, false)
    : totalWorkingHourStr;
  const initialValues = {
    isWorkerMarkedNoShow,
    isProviderMarkedNoShow,
    isSuperAdminMarkedNoShow,
    isWorkerConfirmedAttendance,
    isProviderConfirmedAttendance,
    breakTimeGivenByProvider: formatHour(breakTimeGivenByProvider, userNativeLang, false),
    breakTimeGivenByWorker: formatHour(breakTimeGivenByWorker, userNativeLang, false),
    overTimeGivenByProvider: formatHour(overTimeGivenByProvider, userNativeLang, false),
    overTimeGivenByWorker: formatHour(overTimeGivenByWorker, userNativeLang, false),
    startDate,
    endDate,
    startTime,
    endTime,
    workerStartDate,
    workerEndDate,
    workerStartTime,
    workerEndTime,
    paymentPerDay: formatMoney(intl, price),
    totalWorkingHour: totalWorkingHourStr,
    totalWorkingHourByProvider: totalWorkingHourByProviderStr,
    totalWorkingHourByWorker: totalWorkingHourByWorkerStr,
    isWorkerLogAcceptedByAdmin,
    isProviderLogAcceptedByAdmin,
    attendanceStartDate,
    attendanceEndDate,
    attendanceStatus,
    totalWorkingHourByProviderInt: totalWorkingHourByProvider,
    totalWorkingHourByWorkerInt: totalWorkingHourByWorker,
    isDisputeMarkedSolvedByAdmin,
    isDisputeRaisedByProvider,
    isDisputeRaisedByWorker,
    endingShiftDateTime: endingShiftDateTime,
    startingShiftDateTime: startingShiftDateTime,
    workerStartingShiftDateTime: workerStartingShiftDateTime,
    workerEndingShiftDateTime: workerEndingShiftDateTime,
    lastConfirmedWorkingHour,
    paymentDate,
    disputeMessage,
  };

  function formateDate(date, format = 'DD/MM/YYYY') {
    const d = new Date(date);
    const offset = d.getTimezoneOffset() * -1;
    return moment(date)
      .subtract(offset, 'm')
      .format(format);
    // return isPositiveOffset
    //   ? moment(date)
    //       .subtract(userUtcOffset, 'm')
    //       .format(format)
    //   : moment(date)
    //       .add(userUtcOffset, 'm')
    //       .format(format);
  }
  function formateTime(date) {
    const d = new Date(date);
    const offset = d.getTimezoneOffset() * -1;
    // return isPositiveOffset
    //   ? moment(date)
    //       .subtract(userUtcOffset, 'm')
    //       .format('HH:mm')
    //   : moment(date)
    //       .add(userUtcOffset, 'm')
    //       .format('HH:mm');
    return moment(date)
      .subtract(offset, 'm')
      .format('HH:mm');
  }

  const onSubmit = values => {
    const {
      breakTimeGivenByProvider: providerBreakTime,
      breakTimeGivenByWorker: workerBreakTime,
      overTimeGivenByProvider: providerOverTime,
      overTimeGivenByWorker: workerOverTime,
      startTime,
      endTime,
      workerStartTime,
      workerEndTime,
      endingShiftDateTime,
      startingShiftDateTime,
      workerStartingShiftDateTime,
      workerEndingShiftDateTime,
    } = values;
    const userUtcOffset = moment().utcOffset();
    const providerEndHour = getTotalHourFromString(endTime);
    const providerStartHour = getTotalHourFromString(startTime);
    const workerEndHour = getTotalHourFromString(workerEndTime);
    const workerStartHour = getTotalHourFromString(workerStartTime);
    const startDate = formateDate(startingShiftDateTime, 'YYYY-MM-DDT00:00:00');
    const endDate = formateDate(endingShiftDateTime, 'YYYY-MM-DDT00:00:00');
    const workerStartDate = formateDate(workerStartingShiftDateTime, 'YYYY-MM-DDT00:00:00');
    const workerEndDate = formateDate(workerEndingShiftDateTime, 'YYYY-MM-DDT00:00:00');
    const newStartingShiftDateTime = moment(startDate)
      .add(providerStartHour, 'hours')
      .utc()
      .add(userUtcOffset, 'm')
      .toISOString();
    const newEndingShiftDateTime = moment(endDate)
      .add(providerEndHour, 'hours')
      .utc()
      .add(userUtcOffset, 'm')
      .toISOString();
    const newWorkerStartingShiftDateTime = moment(workerStartDate)
      .add(workerStartHour, 'hours')
      .utc()
      .add(userUtcOffset, 'm')
      .toISOString();
    const newWorkerEndingShiftDateTime = moment(workerEndDate)
      .add(workerEndHour, 'hours')
      .utc()
      .add(userUtcOffset, 'm')
      .toISOString();
    const breakTimeGivenByWorker = getTotalHourFromString(workerBreakTime);
    const breakTimeGivenByProvider = getTotalHourFromString(providerBreakTime);
    const overTimeGivenByWorker = getTotalHourFromString(workerOverTime);
    const overTimeGivenByProvider = getTotalHourFromString(providerOverTime);
    const updateData = isSuperAdmin
      ? {
          startingShiftDateTime: newStartingShiftDateTime,
          endingShiftDateTime: newEndingShiftDateTime,
          workerStartingShiftDateTime: newWorkerStartingShiftDateTime,
          workerEndingShiftDateTime: newWorkerEndingShiftDateTime,
          breakTimeGivenByWorker,
          breakTimeGivenByProvider,
          overTimeGivenByWorker,
          overTimeGivenByProvider,
          id: _id,
        }
      : isProvider
      ? {
          isProviderConfirmedAttendance: false,
          startingShiftDateTime: newStartingShiftDateTime,
          endingShiftDateTime: newEndingShiftDateTime,
          breakTimeGivenByProvider,
          overTimeGivenByProvider,
          id: _id,
        }
      : {
          isWorkerConfirmedAttendance: false,
          workerStartingShiftDateTime: newWorkerStartingShiftDateTime,
          workerEndingShiftDateTime: newWorkerEndingShiftDateTime,
          breakTimeGivenByWorker,
          overTimeGivenByWorker,
          id: _id,
        };

    onPropsUpdateTimestatment({ updateData, type });
  };

  const onConfrimAttendenace = values => {
    const updateData = { ...values, id: _id };
    return onPropsUserConfrimAttendence({ updateData, type });
  };

  const onHandleNoShow = values => {
    const updateData = { ...values, id: _id };
    onPropsNoShowSubmit({ updateData, type });
  };

  const onHandleAcceptLog = values => {
    const updateData = { ...values, id: _id };
    onPropsAcceptWorkLog({ updateData, type });
  };
  const handleDisputeSolved = values => {
    const updateData = { ...values, id: _id };
    onPropsDisputeSolved({ updateData, type });
  };

  const handleDisputeRaised = values => {
    const updateData = { ...values, id: _id };
    onPropsDisputeRaised({ updateData, type });
  };

  return (
    <FinalForm
      formId={_id}
      initialValues={initialValues}
      onSubmit={onSubmit}
      onUserConfrimAttendenace={onConfrimAttendenace}
      onNoShow={onHandleNoShow}
      onAcceptLog={onHandleAcceptLog}
      handleDisputeSolved={handleDisputeSolved}
      handleDisputeRaised={handleDisputeRaised}
      updateInProgress={!!(timeStateUpdateInProgress && lastSubmitIds.update === _id)}
      updateErr={lastSubmitIds.update === _id ? timeStatementUpdateError : null}
      confrimInProgress={!!(timeStateUpdateInProgress && lastSubmitIds.confirmed === _id)}
      confrimErr={lastSubmitIds.confirmed === _id ? timeStatementUpdateError : null}
      noShowInProgress={!!(timeStateUpdateInProgress && lastSubmitIds.noShow === _id)}
      noShowErr={lastSubmitIds.noShow === _id ? timeStatementUpdateError : null}
      workerLogAcceptInProgress={
        !!(timeStateUpdateInProgress && lastSubmitIds.acceptWorkerLog === _id)
      }
      workerLogAcceptErr={lastSubmitIds.acceptWorkerLog === _id ? timeStatementUpdateError : null}
      providerLogAcceptInProgress={
        !!(timeStateUpdateInProgress && lastSubmitIds.acceptProviderLog === _id)
      }
      providerLogAcceptErr={
        lastSubmitIds.acceptProviderLog === _id ? timeStatementUpdateError : null
      }
      disputeSolveInProgress={!!(timeStateUpdateInProgress && lastSubmitIds.disputeSolve === _id)}
      disputeSolveErr={lastSubmitIds.disputeSolve === _id ? timeStatementUpdateError : null}
      disputeRaisedInProgress={!!(timeStateUpdateInProgress && lastSubmitIds.disputeRaised === _id)}
      disputeRaisedErr={lastSubmitIds.disputeRaised === _id ? timeStatementUpdateError : null}
      {...props}
      render={formProps => {
        const {
          handleSubmit,
          values,
          formId,
          intl,
          isProvider,
          pristine,
          updateInProgress,
          updateErr,
          form,
          onUserConfrimAttendenace,
          confrimInProgress,
          confrimErr,
          onNoShow,
          noShowInProgress,
          noShowErr,
          onAcceptLog,
          workerLogAcceptInProgress,
          workerLogAcceptErr,
          providerLogAcceptInProgress,
          providerLogAcceptErr,
          disputeSolveInProgress,
          disputeSolveErr,
          handleDisputeSolved,
          disputeRaisedInProgress,
          disputeRaisedErr,
          handleDisputeRaised,
          invalid,
          errors,
          isDisputeAttendance: isPropsDisputeAttendance,
          onManageDisableScrolling,
        } = formProps;
        const {
          startDate,
          endDate,
          startTime,
          endTime,
          workerStartDate,
          workerEndDate,
          workerStartTime,
          workerEndTime,
          breakTimeGivenByWorker,
          breakTimeGivenByProvider,
          overTimeGivenByWorker,
          overTimeGivenByProvider,
          paymentPerDay,
          isProviderConfirmedAttendance,
          isWorkerConfirmedAttendance,
          showConfirmModal = false,
          showNoShowModal = false,
          isWorkerMarkedNoShow,
          isProviderMarkedNoShow,
          isSuperAdminMarkedNoShow,
          totalWorkingHourByProvider,
          totalWorkingHourByWorker,
          isWorkerLogAcceptedByAdmin,
          isProviderLogAcceptedByAdmin,
          attendanceStartDate,
          attendanceEndDate,
          attendanceStatus,
          totalWorkingHourByProviderInt,
          totalWorkingHourByWorkerInt,
          isDisputeMarkedSolvedByAdmin,
          isDisputeRaisedByProvider,
          isDisputeRaisedByWorker,
          shouldEditWorkerForm,
          shouldEditProviderForm,
          lastConfirmedWorkingHour,
          paymentDate,
          showDisputeMessageModel = false,
          disputeMessage,
        } = values;

        const isWorkingTimeDiff =
          totalWorkingHourByProviderInt !== totalWorkingHourByWorkerInt ||
          (totalWorkingHourByProviderInt === totalWorkingHourByWorkerInt &&
            lastConfirmedWorkingHour !== totalWorkingHourByWorkerInt);

        const isDisputeAttendance =
          adminTimestatmentType.dispute === attendanceStatus || isPropsDisputeAttendance;
        const userUtcOffsetHour = moment().utcOffset() / 60;
        const attEndDate = attendanceEndDate
          ? moment(attendanceEndDate)
              .add(config.workTimestatementUpdateLimit, 'hours')
              .subtract(userUtcOffsetHour, 'h')
          : null;
        const attStartDate = attendanceEndDate
          ? moment(attendanceEndDate).subtract(userUtcOffsetHour, 'h')
          : null;

        const isTimestatmentSettled = !!(paymentDate && !isWorkingTimeDiff);

        // [
        //   adminTimestatmentType.attendanceConfirmed,
        //   adminTimestatmentType.paid,
        // ].includes(attendanceStatus);

        const isWorkHasEnded = moment().isAfter(attStartDate);

        const isCanEdit = attEndDate
          ? isTimestatmentSettled
            ? false
            : moment().isAfter(attStartDate) && moment().isBefore(attEndDate)
          : true;

        const isEditDateExpired = attEndDate ? moment().isAfter(attEndDate) : true;
        const isWorker = !isProvider && !isSuperAdmin;
        const isWorkLogAcceptedByAdmin = isWorkerLogAcceptedByAdmin || isProviderLogAcceptedByAdmin;
        const isDisputedAttendance =
          isDisputeAttendance || isDisputeRaisedByProvider || isDisputeRaisedByWorker;
        const isAdminEditable =
          isDisputedAttendance && !(isWorkLogAcceptedByAdmin || isSuperAdminMarkedNoShow);

        const shouldShowWorkLogBtn =
          isDisputedAttendance && !(isDisputeMarkedSolvedByAdmin || isSuperAdminMarkedNoShow);

        const isProviderAttendanceEditable = isSuperAdmin
          ? isAdminEditable
          : isProvider
          ? isDisputedAttendance
            ? false
            : isWorkHasEnded &&
              (isProviderConfirmedAttendance ? isWorkingTimeDiff : isCanEdit || isWorkingTimeDiff) // || !isProviderConfirmedAttendance
          : false;

        const isProviderAttendanceFormEditable =
          isProviderAttendanceEditable && (isSuperAdmin || shouldEditProviderForm);

        const isWorkerAttendanceEditable = isSuperAdmin
          ? isAdminEditable
          : isWorker
          ? isDisputedAttendance
            ? false
            : isWorkHasEnded &&
              (isWorkerConfirmedAttendance ? isWorkingTimeDiff : isCanEdit || isWorkingTimeDiff) //|| !isWorkerConfirmedAttendance
          : false;

        const isWorkerAttendanceFormEditable =
          isWorkerAttendanceEditable && (isSuperAdmin || shouldEditWorkerForm);

        const isPaymentCompleted =
          paymentDate &&
          [adminTimestatmentType.attendanceConfirmed, adminTimestatmentType.paid].includes(
            attendanceStatus
          ) &&
          totalWorkingHourByProviderInt === totalWorkingHourByWorkerInt;

        const shouldShowNoShowBtn = isSuperAdmin
          ? isDisputedAttendance && !isDisputeMarkedSolvedByAdmin
          : !paymentDate; //isWorkingTimeDiff;

        const showDisputeBtn = isDisputeMarkedSolvedByAdmin
          ? false
          : isEditDateExpired && !isPaymentCompleted;
        // : [adminTimestatmentType.attendanceConfirmed, adminTimestatmentType.paid].includes(
        //     attendanceStatus
        //   )
        // ? isWorkingTimeDiff
        // : !isEditDateExpired || isDisputeAttendance
        // ? false
        // : isWorkingTimeDiff;
        const workerStartTimeId = `${formId}.worker.startTime`;
        const workerEndTimeId = `${formId}.worker.endTime`;
        const providerStartTimeId = `${formId}.provider.startTime`;
        const providerEndTimeId = `${formId}.provider.endTime`;
        const workerBreakTimeId = `${formId}.worker.breakTime`;
        const providerBreakTimeId = `${formId}.provider.breakTime`;
        const providerOverTimeId = `${formId}.provider.overTime`;
        const workerOverTimeId = `${formId}.worker.overTime`;

        const attendanceStart = moment(attendanceStartDate)
          .subtract(userUtcOffsetHour, 'hour')
          .toDate();
        const attendanceEnd = moment(attendanceEndDate)
          .subtract(userUtcOffsetHour, 'hour')
          .toDate();
        const attendanceMaxEndHour =
          (attendanceEnd.getHours() + attendanceEnd.getMinutes() / 60) % ONE_DAY_HOURS;
        const attendanceMinStartHour =
          (attendanceStart.getHours() + attendanceStart.getMinutes() / 60) % ONE_DAY_HOURS;
        const nextDayHourOffset = attendanceMaxEndHour < attendanceMinStartHour ? ONE_DAY_HOURS : 0;
        const ref = {
          providerEndTimeHour: getTotalHourFromString(endTime),
          customerEndTimeHour: getTotalHourFromString(workerEndTime),
          providerStartTimeHour: getTotalHourFromString(startTime),
          customerStartTimeHour: getTotalHourFromString(workerStartTime),
        };
        if (ref.providerEndTimeHour <= MAX_WORKING_HOUR) {
          ref.providerEndTimeHour += nextDayHourOffset;
        }

        if (ref.providerStartTimeHour <= MAX_WORKING_HOUR) {
          ref.providerStartTimeHour += nextDayHourOffset;
        }

        if (ref.customerEndTimeHour <= MAX_WORKING_HOUR) {
          ref.customerEndTimeHour += nextDayHourOffset;
        }

        if (ref.customerStartTimeHour <= MAX_WORKING_HOUR) {
          ref.customerStartTimeHour += nextDayHourOffset;
        }

        const invalidTimeMsg = intl.formatMessage({
          id: 'GigAttendance.attendance.invalidTime',
        });
        const timePlaceholder = intl.formatMessage({
          id: 'GigAttendance.attendance.timePlaceholder',
        });

        const handleOnConfirm = e => {
          e.preventDefault();
          if (!pristine || shouldEditWorkerForm || shouldEditProviderForm) return;
          form.change('showConfirmModal', true);
        };

        const onConfrimAttendenace = e => {
          e.preventDefault();
          if (!isProvider && !isWorker) return;
          const updateData = isWorker
            ? { isWorkerConfirmedAttendance: true }
            : { isProviderConfirmedAttendance: true };
          onUserConfrimAttendenace(updateData).then(() => {
            form.change('showConfirmModal', false);
          });
        };

        const onCancel = e => {
          e.preventDefault();
          form.batch(() => {
            form.change('showConfirmModal', false);
            form.change('showNoShowModal', false);
            form.change('showDisputeMessageModel', false);
          });
        };

        const handleNoShow = e => {
          e.preventDefault();
          if (workerLogAcceptInProgress || providerLogAcceptInProgress) return;
          if (!shouldShowNoShowBtn) return;
          if (isProvider && !isSuperAdmin && isProviderMarkedNoShow) return;
          else if (isWorker && isWorkerMarkedNoShow) return;
          const updateData = isWorker
            ? { isWorkerMarkedNoShow: !isWorkerMarkedNoShow }
            : isSuperAdmin
            ? { isSuperAdminMarkedNoShow: !isSuperAdminMarkedNoShow }
            : isProvider
            ? { isProviderMarkedNoShow: !isProviderMarkedNoShow }
            : {};
          onNoShow(updateData);
        };

        const onAcceptWorkerLog = e => {
          e.preventDefault();
          if (noShowInProgress || providerLogAcceptInProgress) return;
          if (!isSuperAdmin || !shouldShowWorkLogBtn || isProviderLogAcceptedByAdmin) return;
          const updateData = { isWorkerLogAcceptedByAdmin: !isWorkerLogAcceptedByAdmin };
          onAcceptLog(updateData);
        };

        const onAcceptProviderLog = e => {
          e.preventDefault();
          if (noShowInProgress || workerLogAcceptInProgress) return;
          if (!isSuperAdmin || !shouldShowWorkLogBtn || isWorkerLogAcceptedByAdmin) return;
          const updateData = {
            isProviderLogAcceptedByAdmin: !isProviderLogAcceptedByAdmin,
          };
          onAcceptLog(updateData);
        };

        const onSolveDispute = e => {
          e.preventDefault();
          if (!isSuperAdmin || isAdminEditable) return;
          const updateData = { isDisputeMarkedSolvedByAdmin: true, disputeMessage };
          handleDisputeSolved(updateData);
        };
        const showDisputeMessageModelCb = e => {
          e.preventDefault();
          form.change('showDisputeMessageModel', true);
        };

        const onDisputeRaise = e => {
          e.preventDefault();
          if (isSuperAdmin) return;
          const updateData = isProvider
            ? { isDisputeRaisedByProvider: true }
            : isWorker
            ? { isDisputeRaisedByWorker: true }
            : {};
          handleDisputeRaised(updateData);
        };

        const noShowTag = () => {
          const tags = [];
          if (!paymentDate) {
            tags.push(
              <span className={classNames(css.accpetLogTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.paymentPending',
                })}
              </span>
            );
          }
          if (!isDisputeMarkedSolvedByAdmin && isDisputeRaisedByWorker) {
            tags.push(
              <span className={classNames(css.noShowTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.workerRaisedDispute',
                })}
              </span>
            );
          }
          if (!isDisputeMarkedSolvedByAdmin && isDisputeRaisedByProvider) {
            tags.push(
              <span className={classNames(css.noShowTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.providerRaisedDispute',
                })}
              </span>
            );
          }
          if (isDisputeMarkedSolvedByAdmin && isProviderLogAcceptedByAdmin) {
            tags.push(
              <span className={classNames(css.accpetLogTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.providerLogAccepted',
                })}
              </span>
            );
          }
          if (isDisputeMarkedSolvedByAdmin && isWorkerLogAcceptedByAdmin) {
            tags.push(
              <span className={classNames(css.accpetLogTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.workerLogAccepted',
                })}
              </span>
            );
          }
          if (isSuperAdmin) {
            if (isWorkerMarkedNoShow) {
              tags.push(
                <span className={classNames(css.noShowTag)}>
                  {intl.formatMessage({
                    id: 'GigAttendance.attendance.workerMarkerNoShow',
                  })}
                </span>
              );
            }
            if (isProviderMarkedNoShow) {
              tags.push(
                <span className={classNames(css.noShowTag)}>
                  {intl.formatMessage({
                    id: 'GigAttendance.attendance.providerMarkerNoShow',
                  })}
                </span>
              );
            }
          }
          if (isSuperAdminMarkedNoShow) {
            tags.push(
              <span className={classNames(css.noShowTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.adminMarkerNoShow',
                })}
              </span>
            );
          }
          if (!isSuperAdmin && isWorkerMarkedNoShow) {
            tags.push(
              <span className={classNames(css.noShowTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.workerMarkerNoShow',
                })}
              </span>
            );
          }
          if (!isSuperAdmin && isProviderMarkedNoShow) {
            tags.push(
              <span className={classNames(css.noShowTag)}>
                {intl.formatMessage({
                  id: 'GigAttendance.attendance.providerMarkerNoShow',
                })}
              </span>
            );
          }

          if (tags.length < 1) return null;
          return tags.map((tag, i) => <React.Fragment key={i}>{tag}</React.Fragment>);
        };

        const enableProviderFormEdit = e => {
          e.preventDefault();
          if (shouldEditProviderForm) {
            form.change('shouldEditProviderForm', false);
          } else {
            form.change('shouldEditProviderForm', isProviderAttendanceEditable);
          }
        };

        const enableWorkerFormEdit = e => {
          e.preventDefault();

          if (shouldEditWorkerForm) {
            form.change('shouldEditWorkerForm', false);
          } else {
            form.change('shouldEditWorkerForm', isWorkerAttendanceEditable);
          }
        };

        const onShowNoShowModal = e => {
          e.preventDefault();
          if (workerLogAcceptInProgress || providerLogAcceptInProgress) return;
          if (!shouldShowNoShowBtn) return;
          if (isProvider && !isSuperAdmin && isProviderMarkedNoShow) return;
          else if (isWorker && isWorkerMarkedNoShow) return;
          form.change('showNoShowModal', true);
        };

        const onTimeChange = (value, { name, shiftName, dateName, isForEndTime }) => {
          const initialValueNum = getTotalHourFromString(value);
          const hourValue = parseInt(initialValueNum, 10);
          let valueNum = initialValueNum % ONE_DAY_HOURS;
          if (valueNum < attendanceMinStartHour) {
            valueNum += nextDayHourOffset;
          }
          const nextDayAttendanceMaxEndHour = attendanceMaxEndHour + nextDayHourOffset;
          const isInValidRange = isForEndTime
            ? valueNum > attendanceMinStartHour && valueNum <= nextDayAttendanceMaxEndHour
            : valueNum >= attendanceMinStartHour && valueNum < nextDayAttendanceMaxEndHour;
          // if (!isInValidRange) return;
          valueNum %= ONE_DAY_HOURS;
          const utcOffset = moment().utcOffset();
          let newStartDate = null;
          if (valueNum < attendanceMinStartHour && hourValue !== ONE_DAY_HOURS) {
            newStartDate = moment(attendanceEnd).format('MM-DD-YYYY');
          } else {
            newStartDate = moment(attendanceStart).format('MM-DD-YYYY');
          }
          if (newStartDate) {
            newStartDate = moment(newStartDate)
              .add(utcOffset, 'm')
              .add(Math.abs(utcOffset), 'm')
              .toISOString();
            form.batch(() => {
              form.change(dateName, moment(newStartDate).format('DD/MM/YYYY'));
              form.change(shiftName, newStartDate);
            });
          }
          form.change(name, value);
        };

        const hasNoShowed =
          (isProvider && isProviderMarkedNoShow) ||
          (isWorker && isWorkerMarkedNoShow) ||
          (isSuperAdmin && isSuperAdminMarkedNoShow);

        return (
          <Form onSubmit={handleSubmit}>
            <div className={css.noShowWrapper}>
              {/* {shouldShowNoShowBtn ? ( */}
              <SecondaryButton
                className={classNames(css.noShowBtn, {
                  [css.filledNoShowBtn]: hasNoShowed,
                })}
                onClick={onShowNoShowModal}
                type="button"
                disabled={!shouldShowNoShowBtn}
              >
                <FormattedMessage id="GigAttendance.attendance.noShowButton" />
              </SecondaryButton>
              {/* ) : null} */}

              {noShowTag()}
            </div>

            {workerLogAcceptErr ? (
              <p className={classNames(css.error)}>
                <FormattedMessage id="GigAttendance.attendance.workerLogAcceptFailed" />
              </p>
            ) : null}
            {providerLogAcceptErr ? (
              <p className={classNames(css.error)}>
                <FormattedMessage id="GigAttendance.attendance.providerLogAcceptFailed" />
              </p>
            ) : null}
            <div className={css.workerAttendance}>
              <div className={css.top}>
                <div className={css.title}>
                  <h3>
                    <FormattedMessage id="GigAttendance.attendance.worker" />
                  </h3>
                  {isWorkerConfirmedAttendance ? (
                    <div className={css.disputeAndConfirmedAttendanceContainer}>
                      <span className={css.confirmedAttendance}>
                        <FormattedMessage id="GigAttendance.attendance.confirmed" />
                      </span>
                    </div>
                  ) : (
                    <div className={css.disputeAndConfirmedAttendanceContainer}>
                      <span className={css.notConfirmedAttendance}>
                        <FormattedMessage id="GigAttendance.attendance.notConfirmed" />
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className={css.bottom}>
                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.startDate" />}
                  value={workerStartDate}
                  className={css.info}
                />
                <EditableDiv
                  isEditable={isWorkerAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.startTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={workerStartTimeId}
                  inputName={'workerStartTime'}
                  validate={isHourBetweenValue({
                    message: invalidTimeMsg,
                    minValue: attendanceMinStartHour,
                    maxValue: ref.customerEndTimeHour,
                    checkMaxValueForEqual: true,
                    addWhenLessThan: MAX_WORKING_HOUR + 1,
                    hourOffset: nextDayHourOffset,
                  })}
                  key={`workerStartTime-${ref.customerEndTimeHour}`}
                  className={isWorkerAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={workerStartTime}
                  onChange={val => {
                    onTimeChange(val, {
                      name: 'workerStartTime',
                      shiftName: 'workerStartingShiftDateTime',
                      dateName: 'workerStartDate',
                    });
                  }}
                />
                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.endDate" />}
                  value={workerEndDate}
                  className={css.info}
                />
                <EditableDiv
                  isEditable={isWorkerAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.endTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={workerEndTimeId}
                  inputName={'workerEndTime'}
                  validate={isHourBetweenValue({
                    message: invalidTimeMsg,
                    minValue: ref.customerStartTimeHour,
                    maxValue: attendanceMaxEndHour + nextDayHourOffset,
                    checkMinValueForEqual: true,
                    addWhenLessThan: MAX_WORKING_HOUR + 1,
                    hourOffset: nextDayHourOffset,
                  })}
                  className={isWorkerAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={workerEndTime}
                  onChange={val =>
                    onTimeChange(val, {
                      name: 'workerEndTime',
                      shiftName: 'workerEndingShiftDateTime',
                      dateName: 'workerEndDate',
                      isForEndTime: true,
                    })
                  }
                  key={`workerEndTime-${ref.customerStartTimeHour}`}
                />
                <EditableDiv
                  isEditable={isWorkerAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.breakTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={workerBreakTimeId}
                  inputName={'breakTimeGivenByWorker'}
                  validate={isHourBelowMaxValue(invalidTimeMsg, ONE_DAY_HOURS)}
                  className={isWorkerAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={breakTimeGivenByWorker}
                />
                <EditableDiv
                  isEditable={isWorkerAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.overTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={workerOverTimeId}
                  inputName={'overTimeGivenByWorker'}
                  validate={isHourBelowMaxValue(invalidTimeMsg, ONE_DAY_HOURS)}
                  className={isWorkerAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={overTimeGivenByWorker}
                />
                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.totalWorkingHour" />}
                  value={totalWorkingHourByWorker}
                  className={css.info}
                />

                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.paymentPerDay" />}
                  value={paymentPerDay}
                  className={css.info}
                />
              </div>
              {isWorker ? (
                <div className={css.editButtons}>
                  {pristine ? (
                    <PrimaryButton
                      className={css.modufyBtn}
                      type="button"
                      onClick={enableWorkerFormEdit}
                      disabled={!pristine || !isWorkerAttendanceEditable}
                    >
                      <FormattedMessage
                        id={
                          shouldEditWorkerForm
                            ? 'GigAttendance.attendance.cancelModifyButton'
                            : 'GigAttendance.attendance.modifyButton'
                        }
                      />
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      className={css.modufyBtn}
                      disabled={pristine || invalid || !isWorkerAttendanceEditable}
                      type="submit"
                      inProgress={updateInProgress}
                    >
                      <FormattedMessage id="GigAttendance.attendance.saveButton" />
                    </PrimaryButton>
                  )}
                  <SecondaryButton
                    className={css.confirmBtn}
                    type="button"
                    onClick={handleOnConfirm}
                    disabled={!pristine || shouldEditWorkerForm || !isWorkerAttendanceEditable}
                  >
                    <FormattedMessage id="GigAttendance.attendance.confirmButton" />
                  </SecondaryButton>

                  {isDisputeRaisedByWorker ? null : (
                    <InlineTextButton
                      className={css.raiseDisputeBtn}
                      inProgress={disputeRaisedInProgress}
                      type="button"
                      onClick={onDisputeRaise}
                      disabled={!pristine || shouldEditWorkerForm || !showDisputeBtn}
                    >
                      <FormattedMessage id="GigAttendance.attendance.raiseDispute" />
                    </InlineTextButton>
                  )}
                </div>
              ) : null}
              {isSuperAdmin || isProvider ? null : updateErr ? (
                <p className={classNames(css.error, css.updateError)}>
                  {updateErr?.customMessage?.[userNativeLang] || (
                    <FormattedMessage id="GigAttendance.attendance.attendanceUpdateFailed" />
                  )}
                </p>
              ) : disputeRaisedErr ? (
                <p className={classNames(css.error, css.updateError)}>
                  <FormattedMessage id="GigAttendance.attendance.disputeRaiseFailed" />
                </p>
              ) : null}
              {isWorker ? (
                <div className={css.disputeDisableTextWrapper}>
                  <p>
                    <InfoIcon />
                    &nbsp; &nbsp;
                    <FormattedMessage
                      id={'GigAttendance.confirmHelperText'}
                      values={{ time: config.workTimestatementUpdateLimit }}
                    />
                  </p>
                  <p>
                    <InfoIcon />
                    &nbsp; &nbsp;
                    <FormattedMessage
                      id={'GigAttendance.disputeEnableText'}
                      values={{ time: config.workTimestatementUpdateLimit }}
                    />
                  </p>
                </div>
              ) : null}
            </div>
            <div className={css.bussinessAttendance}>
              <div className={css.top}>
                <div className={css.title}>
                  <h3>
                    <FormattedMessage id="GigAttendance.attendance.provider" />
                  </h3>
                  {isProviderConfirmedAttendance ? (
                    <div className={css.disputeAndConfirmedAttendanceContainer}>
                      <span className={css.confirmedAttendance}>
                        <FormattedMessage id="GigAttendance.attendance.confirmed" />
                      </span>
                    </div>
                  ) : (
                    <div className={css.disputeAndConfirmedAttendanceContainer}>
                      <span className={css.notConfirmedAttendance}>
                        <FormattedMessage id="GigAttendance.attendance.notConfirmed" />
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className={css.bottom}>
                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.startDate" />}
                  value={startDate}
                  className={css.info}
                />
                <EditableDiv
                  isEditable={isProviderAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.startTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={providerStartTimeId}
                  inputName={'startTime'}
                  validate={isHourBetweenValue({
                    message: invalidTimeMsg,
                    minValue: attendanceMinStartHour,
                    maxValue: ref.providerEndTimeHour,
                    checkMaxValueForEqual: true,
                    addWhenLessThan: MAX_WORKING_HOUR + 1,
                    hourOffset: nextDayHourOffset,
                  })}
                  key={`startTime-${ref.providerEndTimeHour}`}
                  className={isProviderAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={startTime}
                  onChange={val =>
                    onTimeChange(val, {
                      name: 'startTime',
                      shiftName: 'startingShiftDateTime',
                      dateName: 'startDate',
                    })
                  }
                />

                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.endDate" />}
                  value={endDate}
                  className={css.info}
                />

                <EditableDiv
                  isEditable={isProviderAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.endTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={providerEndTimeId}
                  inputName={'endTime'}
                  validate={isHourBetweenValue({
                    message: invalidTimeMsg,
                    minValue: ref.providerStartTimeHour,
                    maxValue: attendanceMaxEndHour + nextDayHourOffset,
                    checkMinValueForEqual: true,
                    addWhenLessThan: MAX_WORKING_HOUR + 1,
                    hourOffset: nextDayHourOffset,
                  })}
                  className={isProviderAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={endTime}
                  key={`endTime-${ref.providerStartTimeHour}`}
                  onChange={val =>
                    onTimeChange(val, {
                      name: 'endTime',
                      shiftName: 'endingShiftDateTime',
                      dateName: 'endDate',
                      isForEndTime: true,
                    })
                  }
                />

                <EditableDiv
                  isEditable={isProviderAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.breakTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={providerBreakTimeId}
                  inputName={'breakTimeGivenByProvider'}
                  validate={isHourBelowMaxValue(invalidTimeMsg, ONE_DAY_HOURS)}
                  className={isProviderAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={breakTimeGivenByProvider}
                />

                <EditableDiv
                  isEditable={isProviderAttendanceFormEditable}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.overTime" />}
                  inputPlaceholder={timePlaceholder}
                  inputId={providerOverTimeId}
                  inputName={'overTimeGivenByProvider'}
                  validate={isHourBelowMaxValue(invalidTimeMsg, ONE_DAY_HOURS)}
                  className={isProviderAttendanceFormEditable ? css.inputInfo : css.disabledInfo}
                  value={overTimeGivenByProvider}
                />
                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.totalWorkingHour" />}
                  value={totalWorkingHourByProvider}
                  className={css.info}
                />

                <EditableDiv
                  isEditable={false}
                  inputLabel={<FormattedMessage id="GigAttendance.attendance.paymentPerDay" />}
                  value={paymentPerDay}
                  className={css.info}
                />
              </div>
              {isProvider && !isSuperAdmin ? (
                <div className={css.editButtons}>
                  {pristine ? (
                    <PrimaryButton
                      className={css.modufyBtn}
                      type="button"
                      onClick={enableProviderFormEdit}
                      disabled={!pristine || !isProviderAttendanceEditable}
                    >
                      <FormattedMessage
                        id={
                          shouldEditProviderForm
                            ? 'GigAttendance.attendance.cancelModifyButton'
                            : 'GigAttendance.attendance.modifyButton'
                        }
                      />
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      className={css.modufyBtn}
                      disabled={pristine || invalid || !isProviderAttendanceEditable}
                      type="submit"
                      inProgress={updateInProgress}
                    >
                      <FormattedMessage id="GigAttendance.attendance.saveButton" />
                    </PrimaryButton>
                  )}
                  <SecondaryButton
                    className={css.confirmBtn}
                    type="button"
                    onClick={handleOnConfirm}
                    disabled={!pristine || shouldEditProviderForm || !isProviderAttendanceEditable}
                  >
                    <FormattedMessage id="GigAttendance.attendance.confirmButton" />
                  </SecondaryButton>

                  {isDisputeRaisedByProvider ? null : (
                    <InlineTextButton
                      className={css.raiseDisputeBtn}
                      inProgress={disputeRaisedInProgress}
                      type="button"
                      onClick={onDisputeRaise}
                      disabled={!pristine || shouldEditProviderForm || !showDisputeBtn}
                    >
                      <FormattedMessage id="GigAttendance.attendance.raiseDispute" />
                    </InlineTextButton>
                  )}
                </div>
              ) : null}
              {isSuperAdmin || isWorker ? null : updateErr ? (
                <p className={classNames(css.error, css.updateError)}>
                  {updateErr?.customMessage?.[userNativeLang] || (
                    <FormattedMessage id="GigAttendance.attendance.attendanceUpdateFailed" />
                  )}
                </p>
              ) : disputeRaisedErr ? (
                <p className={classNames(css.error, css.updateError)}>
                  <FormattedMessage id="GigAttendance.attendance.disputeRaiseFailed" />
                </p>
              ) : null}
              {isProvider && !isSuperAdmin ? (
                <div className={css.disputeDisableTextWrapper}>
                  <p>
                    <InfoIcon />
                    &nbsp; &nbsp;
                    <FormattedMessage
                      id={'GigAttendance.confirmHelperText'}
                      values={{ time: config.workTimestatementUpdateLimit }}
                    />
                  </p>
                  <p>
                    <InfoIcon />
                    &nbsp; &nbsp;
                    <FormattedMessage
                      id={'GigAttendance.disputeEnableText'}
                      values={{ time: config.workTimestatementUpdateLimit }}
                    />
                  </p>
                </div>
              ) : null}
            </div>
            {isSuperAdmin && !isDisputeMarkedSolvedByAdmin ? (
              <div>
                {updateErr ? (
                  <p className={classNames(css.error, css.updateError)}>
                    {updateErr?.customMessage?.[userNativeLang] || (
                      <FormattedMessage id="GigAttendance.attendance.attendanceUpdateFailed" />
                    )}
                  </p>
                ) : null}

                <div className={css.adminBtnWrapper}>
                  {isSuperAdmin && shouldShowWorkLogBtn ? (
                    <>
                      <SecondaryButton
                        className={classNames(css.noShowBtn, {
                          [css.filledNoShowBtn]: isWorkerLogAcceptedByAdmin,
                        })}
                        inProgress={workerLogAcceptInProgress}
                        disabled={isProviderLogAcceptedByAdmin || !pristine}
                        onClick={onAcceptWorkerLog}
                        type="button"
                      >
                        <FormattedMessage id="GigAttendance.attendance.acceptWorkerLog" />
                      </SecondaryButton>
                      <SecondaryButton
                        className={classNames(css.noShowBtn, {
                          [css.filledNoShowBtn]: isProviderLogAcceptedByAdmin,
                        })}
                        inProgress={providerLogAcceptInProgress}
                        disabled={isWorkerLogAcceptedByAdmin || !pristine}
                        onClick={onAcceptProviderLog}
                        type="button"
                      >
                        <FormattedMessage id="GigAttendance.attendance.acceptProviderLog" />
                      </SecondaryButton>
                    </>
                  ) : null}
                  {isAdminEditable ? (
                    <SecondaryButton
                      className={css.saveBtn}
                      disabled={pristine || invalid}
                      type="submit"
                      inProgress={updateInProgress}
                    >
                      <FormattedMessage id="GigAttendance.attendance.saveButton" />
                    </SecondaryButton>
                  ) : null}
                  {isDisputeAttendance ? (
                    <PrimaryButton
                      className={css.saveBtn}
                      type="button"
                      onClick={showDisputeMessageModelCb}
                      disabled={isAdminEditable}
                    >
                      <FormattedMessage id="GigAttendance.attendance.disputeSolvedButton" />
                    </PrimaryButton>
                  ) : null}
                </div>
              </div>
            ) : null}
            {isDisputeMarkedSolvedByAdmin && disputeMessage ? (
              <div className={css.disputeNote}>
                <h3>
                  <FormattedMessage id="GigAttendance.attendance.disputeNote" />
                </h3>
                <span>{disputeMessage}</span>
              </div>
            ) : null}
            <Modal
              isOpen={showConfirmModal}
              onManageDisableScrolling={onManageDisableScrolling}
              onClose={onCancel}
              id={`attendance.confirmModal-${formId}`}
              showCloseButton={false}
              containerClassName={css.modelContainer}
              usePortal
            >
              {showConfirmModal ? (
                <div className={css.confirmModal}>
                  <div className={css.modalContent}>
                    <FormattedMessage id="GigAttendance.attendance.confirmHeading" />
                    <FormattedMessage
                      id={
                        isWorkingTimeDiff
                          ? 'GigAttendance.confirmHelperText'
                          : 'GigAttendance.attendance.confirmDesc'
                      }
                    />

                    <div className={css.actionButton}>
                      <PrimaryButton
                        className={css.confirm}
                        onClick={onConfrimAttendenace}
                        inProgress={confrimInProgress}
                      >
                        <FormattedMessage id="GigAttendance.attendance.confirmButton" />
                      </PrimaryButton>
                      <InlineTextButton className={css.cancel} onClick={onCancel}>
                        <FormattedMessage id="GigAttendance.attendance.cancelButton" />
                      </InlineTextButton>
                    </div>
                    {confrimErr ? (
                      <p className={css.error}>
                        <FormattedMessage id="GigAttendance.attendance.attendanceConfirmFailed" />
                      </p>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </Modal>
            <Modal
              isOpen={showNoShowModal}
              onManageDisableScrolling={onManageDisableScrolling}
              onClose={onCancel}
              id={`attendance.noShowModal-${formId}`}
              showCloseButton={false}
              containerClassName={css.modelContainer}
              usePortal
            >
              {showNoShowModal ? (
                <div className={css.confirmModal}>
                  <div className={css.modalContent}>
                    <FormattedMessage
                      id={
                        isWorker
                          ? 'GigAttendance.attendance.noShowWorkerHeading'
                          : 'GigAttendance.attendance.noShowHeading'
                      }
                    />
                    <FormattedMessage
                      id={
                        isWorker
                          ? 'GigAttendance.attendance.noShowWorkerDesc'
                          : 'GigAttendance.attendance.noShowDesc'
                      }
                    />

                    <div className={css.actionButton}>
                      <PrimaryButton
                        className={css.confirm}
                        onClick={handleNoShow}
                        inProgress={noShowInProgress}
                      >
                        <FormattedMessage id="GigAttendance.attendance.confirmButton" />
                      </PrimaryButton>
                      <InlineTextButton className={css.cancel} onClick={onCancel}>
                        <FormattedMessage id="GigAttendance.attendance.cancelButton" />
                      </InlineTextButton>
                    </div>
                    {noShowErr ? (
                      <p className={classNames(css.error, css.noShowError)}>
                        <FormattedMessage id="GigAttendance.attendance.noShowFailed" />
                      </p>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </Modal>
            <Modal
              isOpen={showDisputeMessageModel}
              onManageDisableScrolling={onManageDisableScrolling}
              onClose={onCancel}
              id={`attendance.disputeMessage-${formId}`}
              showCloseButton={false}
              containerClassName={css.modelContainer}
              usePortal
            >
              {showDisputeMessageModel ? (
                <div className={css.confirmModal}>
                  <div className={css.modalContent}>
                    <FormattedMessage id={'GigAttendance.attendance.disputeSolvedHeading'} />
                    <div className={css.modelText}>
                      <FieldTextInput
                        id="disputeMessage"
                        name="disputeMessage"
                        placeholder={intl.formatMessage({
                          id: 'GigAttendance.attendance.disputeSolvedNote',
                        })}
                        type="textarea"
                        className={'textfield'}
                        validate={required(
                          intl.formatMessage({
                            id: 'GigAttendance.attendance.disputeSolvedNoteRequired',
                          })
                        )}
                      />
                    </div>
                    <div className={css.actionButton}>
                      <PrimaryButton
                        className={css.confirm}
                        onClick={onSolveDispute}
                        inProgress={disputeSolveInProgress}
                        disabled={!disputeMessage}
                      >
                        <FormattedMessage id="GigAttendance.attendance.confirmButton" />
                      </PrimaryButton>
                      <InlineTextButton className={css.cancel} onClick={onCancel}>
                        <FormattedMessage id="GigAttendance.attendance.cancelButton" />
                      </InlineTextButton>
                    </div>
                    {disputeSolveErr ? (
                      <p className={classNames(css.error, css.updateError)}>
                        <FormattedMessage id="GigAttendance.attendance.disputeSolveFailed" />
                      </p>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </Modal>
          </Form>
        );
      }}
    />
  );
};

const AttendanceList = props => {
  const {
    timeStatement,
    isProvider,
    isSuperAdmin,
    userNativeLang,
    intl,
    timeStateUpdateInProgress,
    timeStatementUpdateError,
    onUpdateTimeStatement,
    isDisputeAttendance,
    onManageDisableScrolling,
  } = props;
  const {
    attendance = [],
    listing: {
      attributes: { price },
    },
  } = timeStatement;
  const [lastSubmitIds, setLastSubmitIds] = useState({
    update: null,
    confirmed: null,
    noShow: null,
    acceptWorkerLog: null,
    acceptProviderLog: null,
    disputeSolve: null,
    disputeRaised: null,
  });

  const handleSubmit = values => {
    const { updateData, type } = values;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, update: updateData.id }));
    onUpdateTimeStatement(updateData, type)
      .then(() => {
        setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, update: null }));
      })
      .catch(() => {});
  };

  const onUserConfrimAttendenace = values => {
    const { updateData, type } = values;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, confirmed: updateData.id }));
    return onUpdateTimeStatement(updateData, type).then(() => {
      setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, confirmed: null }));
      return 'ok';
    });
  };

  const onNoShowSubmit = values => {
    const { updateData, type } = values;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, noShow: updateData.id }));
    onUpdateTimeStatement(updateData, type).then(() => {
      setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, noShow: null }));
    });
  };
  const onAcceptWorkLog = values => {
    const { updateData, type } = values;
    const updateName =
      typeof updateData.isWorkerLogAcceptedByAdmin === 'boolean'
        ? 'acceptWorkerLog'
        : typeof updateData.isProviderLogAcceptedByAdmin === 'boolean'
        ? 'acceptProviderLog'
        : '';
    if (!updateName) return;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, [updateName]: updateData.id }));
    onUpdateTimeStatement(updateData, type).then(() => {
      setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, [updateName]: null }));
    });
  };

  const onDisputeSolved = values => {
    const { updateData, type } = values;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, disputeSolve: updateData.id }));
    onUpdateTimeStatement(updateData, type).then(() => {
      setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, disputeSolve: null }));
    });
  };

  const onDisputeRaised = values => {
    const { updateData, type } = values;
    setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, disputeRaised: updateData.id }));
    onUpdateTimeStatement(updateData, type).then(() => {
      setLastSubmitIds(lastSubmitIds => ({ ...lastSubmitIds, disputeRaised: null }));
    });
  };

  return (
    <ul className={css.attendanceWrapper}>
      {attendance.map(att => (
        <li key={att._id} className={css.attendance}>
          <Attendance
            att={att}
            price={price}
            intl={intl}
            lastSubmitIds={lastSubmitIds}
            onPropsDisputeRaised={onDisputeRaised}
            onPropsDisputeSolved={onDisputeSolved}
            onPropsAcceptWorkLog={onAcceptWorkLog}
            onPropsNoShowSubmit={onNoShowSubmit}
            onPropsUserConfrimAttendence={onUserConfrimAttendenace}
            onPropsUpdateTimestatment={handleSubmit}
            isProvider={isProvider}
            isSuperAdmin={isSuperAdmin}
            userNativeLang={userNativeLang}
            timeStateUpdateInProgress={timeStateUpdateInProgress}
            timeStatementUpdateError={timeStatementUpdateError}
            isDisputeAttendance={isDisputeAttendance}
            onManageDisableScrolling={onManageDisableScrolling}
          />
        </li>
      ))}
    </ul>
  );
};

const PaymentList = props => {
  const { timeStatement, isProvider, isAdmin, userNativeLang, intl } = props;
  const isWorker = !isProvider && !isAdmin;
  const { attendance, finalPayment, finalWorkingHour } = timeStatement;
  return (
    <div className={css.paymentWrapper}>
      <div className={css.parentWrapperParent}>
        <div>
          <FormattedMessage id="GigAttendance.paymentBreakDown" />
        </div>
        <ul className={css.paymentListWrapper}>
          <li>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.paymentBreakDown.workingDay',
              })}
            </span>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.paymentBreakDown.workingHours',
              })}
            </span>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.paymentBreakDown.wages',
              })}
            </span>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.paymentBreakDown.paymentDate',
              })}
            </span>
          </li>
          {(attendance || []).map(att => {
            const {
              _id: id,
              startingShiftDateTime,
              totalWorkingHour,
              totalPayment,
              totalPaymentForShow,
              paymentDate,
            } = att;
            const startDate = moment(startingShiftDateTime).format('DD/MM/YYYY');
            const paymentDateStr = paymentDate ? moment(paymentDate).format('DD/MM/YYYY') : 'N/A';
            const totalWorkingHourStr = formatHour(totalWorkingHour, userNativeLang, false);
            const totalPaymentStr = formatMoneyAmount(totalPaymentForShow ?? totalPayment, intl);
            return (
              <li key={id}>
                <span>{startDate}</span>
                <span>{totalWorkingHourStr}</span>
                <span>{totalPaymentStr}</span>
                <span>{paymentDateStr}</span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={css.finalDetails}>
        {intl.formatMessage(
          {
            id: 'GigAttendance.finalPaymentDetails',
          },
          {
            amount: <span className={css.amount}>{formatMoneyAmount(finalPayment, intl)}</span>,
            hours: <span className={css.hour}>{formatHour(finalWorkingHour, userNativeLang)}</span>,
          }
        )}
      </div>
    </div>
  );
};

function GigAttendance(props) {
  const {
    currentUser,
    userNativeLang,
    timeStatement,
    history,
    timeStateUpdateInProgress,
    timeStatementUpdateError,
    intl,
    updateTimeStatement: onUpdateTimeStatement,
    queryParams,
    isDisputeAttendance,
    pathParams,
    onManageDisableScrolling,
  } = props;

  const isSuperAdmin =
    currentUser &&
    currentUser.attributes &&
    currentUser.attributes.profile &&
    currentUser.attributes.profile.publicData &&
    currentUser.attributes.profile.publicData.isSuperAdmin;

  const isProvider =
    currentUser &&
    currentUser.attributes &&
    currentUser.attributes.profile &&
    currentUser.attributes.profile.publicData &&
    currentUser.attributes.profile.publicData.isProvider;

  const isWorker = !isProvider && !isSuperAdmin;
  const { gigName, workerName } = pathParams;

  const handleClick = e => {
    e.preventDefault();
    if (isSuperAdmin) {
      const pageName = isDisputeAttendance ? 'AdminDisputePage' : 'AdminTimeStatementPage';
      history.replace(createResourceLocatorString(pageName, routeConfiguration()));
    } else if (isProvider) {
      history.replace(
        createResourceLocatorString('BusinessDashboardTimeStatementPage', routeConfiguration(), {})
      );
    } else if (isWorker) {
      history.replace(
        createResourceLocatorString(
          'WorkerTimestatementPage',
          routeConfiguration(),
          {},
          queryParams
        )
      );
    }
  };

  return timeStatement.attendance &&
    Array.isArray(timeStatement.attendance) &&
    timeStatement.attendance.length > 0 ? (
    <div className={css.root}>
      <div className={css.top}>
        <InlineTextButton className={css.backBtn} onClick={handleClick}>
          <ArrowDown />
          <FormattedMessage id="GigAttendance.back" />
        </InlineTextButton>
      </div>
      <div className={css.body}>
        <div className={css.workDetails}>
          <div className={css.userInfo}>
            <span>
              <NamedLink
                name="ListingPage"
                params={{
                  id: timeStatement.listing?.id.uuid,
                  slug: createSlug(timeStatement.listing?.attributes?.title),
                }}
              >
                {timeStatement.listing?.attributes?.title}
              </NamedLink>
            </span>
            <span>{timeStatement.workerName}</span>
            <span>{getWorkSubcat(timeStatement.listing)?.label?.[userNativeLang]}</span>
          </div>
          <div className={css.info}>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.totalHoursWorked',
              })}
            </span>
            <span>{getTotalWorkingHour(timeStatement, userNativeLang)}</span>
          </div>
          <div className={css.info}>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.WagesPerHour',
              })}
            </span>
            <span>{formatMoney(intl, timeStatement.listing.attributes.price)}</span>
          </div>
          <div className={css.info}>
            <span>
              {intl.formatMessage({
                id: 'GigAttendance.totalPayableAmount',
              })}
            </span>
            <span>{getTotalPayment(intl, timeStatement)}</span>
          </div>
        </div>

        <AttendanceList
          timeStatement={timeStatement}
          isProvider={isProvider}
          isSuperAdmin={isSuperAdmin}
          userNativeLang={userNativeLang}
          intl={intl}
          timeStateUpdateInProgress={timeStateUpdateInProgress}
          timeStatementUpdateError={timeStatementUpdateError}
          onUpdateTimeStatement={onUpdateTimeStatement}
          isDisputeAttendance={isDisputeAttendance}
          onManageDisableScrolling={onManageDisableScrolling}
        />
        <PaymentList
          timeStatement={timeStatement}
          isProvider={isProvider}
          isSuperAdmin={isSuperAdmin}
          userNativeLang={userNativeLang}
          intl={intl}
        />
      </div>
    </div>
  ) : (
    <div className={css.noAttendance}>
      <h3>
        <FormattedMessage
          id="GigAttendance.noTimeStatment"
          values={{ gigName: gigName || workerName }}
        />
      </h3>
    </div>
  );
}

GigAttendance.propTypes = {
  currentUser: propTypes.currentUser,
  transactions: arrayOf(propTypes.transaction),
  timeStatement: object,
  updateTimeStatement: func,
  isAuthenticated: bool,
  timeStateUpdateInProgress: bool,
  timeStatementUpdateError: object,
  history: object,
  intl: intlShape,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { isAuthenticated } = state.Auth;
  const { userNativeLang } = state.UI;

  return {
    currentUser,
    isAuthenticated,
    userNativeLang,
  };
};
const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (id, disableScrolling) =>
    dispatch(manageDisableScrolling(id, disableScrolling)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  injectIntl
)(GigAttendance);
